import { parseZone } from "moment";
const currentDate = parseZone(new Date()).format("YYYY-MM-DD");

export const newRowIndex = 9999;

export const addNewLogisticRow = {
  id: newRowIndex,
  internal_number: "",
  loading_date: currentDate,
  docs_sent_date: currentDate,
  tc: "",
  fv: "",
  way_from: "",
  way_to: "",
  way_text: "",
  note: "",
  amount: "",
  currency: "",
  payment_date: currentDate,
  is_paid: "",
  is_ready: "",
  client: "",
  contractor: "",
  documents: "",
  temporary: true,
  parent_id: null,
};

export const acceptedTypes =
  ".jpg,.png,.bmp,.gif,.tif,.doc,.docx,.xls,.xlsx,.pdf,.txt,.zip,.rar,.7z,.gzip,.ppt,.pptx";

export const EXPORT_TO_EXCEL_TIMEOUT_MESSAGE =
  "The server cannot process the data. Try reducing the specified period";
